<script>
    import marked from 'marked'
    import { createFund } from "../api/fund.js";
    import { SyncLoader } from "svelte-loading-spinners";
    import {toasts} from "../stores.js";

    let created = false;
    let uncopied = true
    let mnemo;
    let textArea = "";
    let title = "";
    let payTo = "";
    let email = "";
    let goal = 0;
    let cashStop = 0
    let files;
    let password = "";
    let confirmPassword = "";
    let duration = 30;

    $: description = ""
    $: creating = false

    $: if (textArea) console.log(textArea.selectionStart, textArea.selectionEnd)
    $: if (description.length > 1000) description = description.substring(0,1000)

    const addLine = (line, selectionStart, selectionEnd) => {
        description = description + line;
        setSelectionRange(textArea, 1, 5);
    }

    const setSelectionRange = (input, selectionStart, selectionEnd) => {
        input.focus();
        if (input) {
            console.log(input.selectionStart, input.selectionEnd)
            input.selectionStart = 0
            input.selectionEnd = 10
            console.log(input.selectionStart, input.selectionEnd)
        }
        console.log(input.selectionStart, input.selectionEnd)
        console.log(input.selectionStart, input.selectionEnd)
    }

    const handleSubmit = () => {
        if (files && files[0] && title != "" && textArea != "" && payTo != "" && email != "") {
            creating = true
            if (password.length < 8) {
                toasts.pushToast("password must be 8 characters long", "error")
                creating = false
            }
            if (password != confirmPassword) {
                toasts.pushToast("passwords don't match", "error")
                creating = false
            }
            if (creating != false) {
                let endDate = Date.now() + (1000 * 60 * 60 * 24 * duration);
                createFund(title, description, email, payTo, files[0], Number(goal), parseInt(Number(cashStop)), password, endDate)
                    .then(async data => {
                        if (data.status == 413) {
                            toasts.pushToast("image to large", "error")
                            creating = false
                            return
                        }
                        if (data.status == 408) {
                            toasts.pushToast("request timed out", "error")
                            creating = false
                            return
                        }
                        else if (data.status != 200) {
                            toasts.pushToast("an error occured", "error")
                            creating = false
                            return
                        }
                        else {
                            let new_data = await data.json()
                            mnemo = new_data.mnemonic
                            created = true
                            creating = false
                        }
                    })
            }
        }
        else toasts.pushToast("form incomplete", "error")
    }

</script>

<div class="main">
    <h1 style="margin-bottom: 0.2rem;">Create a Fundraiser</h1>
    <div class="ui divider divy" style="margin-top: 0.4rem;"></div>

    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; word-wrap: normal; margin-right: 1rem;">Title</h4>
        <input bind:value={title} class="title"/>
    </div>

    <div class="input-row description" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; word-wrap: normal; margin-right: 1rem; white-space: nowrap;">Description</h4>
        <div style="flex-grow: 1;">
            <div class="ui small basic icon buttons">
                <button 
                    on:click={() => addLine("\n\n# Header 1", 0, 15)} 
                    class="ui button" data-bcup-haslogintext="no">
                    H1
                </button>
                <button 
                    on:click={() => addLine("\n\n## Header 2", 0, 15)} 
                    class="ui button">
                    H2
                </button>
                <button 
                    on:click={() => addLine("\n\n### Header 3", 0, 15)} 
                    class="ui button">
                    H3
                </button>
                <button 
                    on:click={() => addLine("\n\n#### Header 4", 0, 15)} 
                    class="ui button">
                    H4
                </button>
                <button 
                    on:click={() => addLine("\n\n- Bullet Point 1", 0, 15)} 
                    class="ui button">
                    <i class="ui icon minus"/>
                </button>
            </div>
            <textarea bind:this={textArea} style="margin-top: 1rem;" class="markdown" bind:value={description}/>
        </div>
    </div>

    <h3 style="margin-bottom: 0px;">Preview</h3>
    <div class="ui divider divy" style="margin-top: 0.4rem;"></div>
    {#if description != ""}
        <div class="preview">
            {@html marked(description)}
        </div>
    {:else}
        <h3>Please enter a description...</h3>
    {/if}

    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; white-space: nowrap; margin-right: 1rem;">Fund Duration</h4>
        <input type="number" min="30" max="180" bind:value={duration} class="title"/>
    </div>

    <h3 style="margin-bottom: 0px;">Payment Details</h3>
    <div class="ui divider divy" style="margin-top: 0.4rem;"></div>

    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; margin-right: 1rem; white-space: nowrap;">BTC Goal</h4>
        <input bind:value={goal} class="title"/>
    </div>

    <div class="input-row">
        <h4 style="margin: 0px; align-self: center; word-wrap: normal; margin-right: 1rem; white-space: nowrap;">USD Cash Stop</h4>
        <input bind:value={cashStop} class="title"/>
    </div>
    <p style="font-size: 12px; margin-top: 0.2rem; margin-bottom: 1rem;">*Releases the fund if the value of the fund reaches the cash stop</p>

    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; word-wrap: normal; margin-right: 1rem; white-space: nowrap;">BTC Address</h4>
        <input bind:value={payTo} class="title"/>
    </div>


    <h3 style="margin-bottom: 0px;">Account Login Details</h3>
    <div class="ui divider divy" style="margin-top: 0.4rem;"></div>
    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; word-wrap: normal; margin-right: 1rem; white-space: nowrap;">Email</h4>
        <input type="email" bind:value={email} class="title"/>
    </div>

    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; word-wrap: normal; margin-right: 1rem; white-space: nowrap;">Password</h4>
        <input type="password" bind:value={password} class="title"/>
    </div>

    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; word-wrap: normal; margin-right: 1rem; white-space: nowrap;">Confirm Password</h4>
        <input type="password" bind:value={confirmPassword} class="title"/>
    </div>

    <h3>Image</h3>
    <input type="file"
        bind:files
        id="avatar" name="avatar"
        accept="image/png, image/jpeg">

    <div class="finish">
            {#if creating}
                <div class="loader">
                    <SyncLoader color="#17C3B2" duration="1s" size="2" unit="rem"/>
                </div>
            {:else}
                <button 
                    on:click={handleSubmit}
                    class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-green">
                    Create Fundraiser
                </button>
            {/if}
    </div>

    {#if created}
        <div class="modal">
            <div class="mnemonic">
                <h2 style="margin-bottom: 0px;">Check your email for a verifivation link</h2>
                <p style="margin-bottom: 2rem;">It may be in your spam folder.</p>
                <button 
                    class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-green"
                    on:click={() => toasts.pushToast("verification email resent", "success")}>
                    Resend Verification
                </button>
            </div>
        </div>
    {/if}
</div>

<style>
    .title:invalid {
        border-color: #F25F5C;
        outline-color: #F25F5C;
    }
    .title:focus:invalid {
        border-color: none;
        outline-color: none;
    }
    .phrase {
        border: 1px solid #CCC;
        border-radius: 0.4rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        width: fit-content;
        width: -moz-fit-content;
        margin-bottom: 1rem;
    }
    .modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: rgba(0, 0, 0, 0.4);
    }
    .mnemonic {
        border-radius: 1rem;
        width: fit-content;
        max-width: 45rem;
        background-color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .loader {
        margin-top: 0.3rem;
    }
    .finish {
        padding-top: 1rem;
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .green-button {
        background-color: #17C3B2 !important;
    }
    .title {
        min-width: 0px;
        flex-grow: 1;
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .markdown {
        width: 100%;
        resize: vertical;
        height: 20rem;
    }
    .main {
        width: 100%;
        margin-bottom: 2rem;
    }

    .description {
        display: block;
    }
    @media only screen and (min-width: 768px) {
        .main {
            max-width: 90%;
            min-width: 30%;
            width: 100%;
        }
        .description {
            display: flex;
        }
    }
    .input-row {
        display: flex;
        flex-direction: row;
        height: fit-content;
        align-items: flex-start;
        justify-content: space-between;
    }
</style>
